import { useContext } from 'react';
import { RadioGroupContext } from '../Context.js';

function useRadioGroup() {
  return useContext(RadioGroupContext);
}

export { useRadioGroup };
